import moment from 'moment';

export default function parseYm(ym: string) {
    const year = Number(ym.substr(0, 4));
    const month = Number(ym.substr(4, 2));

    return moment({ year, month: month - 1, date: 1 });
}
